<script>
import dateRenderer from "@core/mixins/date-renderer";
import ChangesModal from "@core/components/common/changelog/ChangesModal.vue";
import Button from "@core/components/common/Button.vue";
import HamletTable from "@core/components/common/HamletTable.vue";

export default {
    name: "Relations",
    mixins: [dateRenderer],
    components: {
        ChangesModal,
        Button,
        HamletTable,
        ChangeLog: () => import("@core/components/common/changelog/ChangeLog.vue"),
    },
    props: {
        label: {
            default() {
                return this.$t('Component(ChangeLog):relations-label');
            }
        },
        relations: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                    title: this.$t('Component(Grid):column-title'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'createdAt',
                    label: this.$t('Component(Label):created-at'),
                    title: this.$t('Component(Label):created-at'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions'),
                    title: this.$t('Component(Grid):column-actions'),
                    order: 1,
                    active: true,
                },
            ],
            changesLabel: this.$t('Component(ChangeLog):changes-label'),
            changesToShow: [],
        };
    },
    methods: {
        showChanges(relation) {
            this.changesLabel = relation.title;
            this.changesToShow = relation.changeLog.changes;
            this.$nextTick(() => {
                this.$refs.changesModal.show();
            });
        },
        renderTable(config, callback) {
            const start = config.page * config.perPage - config.perPage;
            let end = start + config.perPage;
            if (end > this.relations.length) {
                end = undefined;
            }
            callback(
                this.relations.length,
                this.relations.slice(start, end)
            );
        },
        show() {
            this.$refs['change-log-relations-modal'].show();
        },
    },
}
</script>

<template>
    <div>
        <ChangesModal
            ref="changesModal"
            :label="changesLabel"
            :changes="changesToShow"
        />
        <HamletTable
            card-class="mb-0 pb-0"
            :columns="columns"
            :fetch="renderTable"
        >
            <template #header-label>{{ label }}</template>
            <template #cell-createdAt="data">
                {{ renderDateTime(data.item.changeLog.createdAt) }}
            </template>
            <template #cell-actions="data">
                <Button
                    v-if="data.item.changeLog.changes.length > 0"
                    class="btn-sm mr-1"
                    @click="showChanges(data.item)"
                >
                    {{ $t('Component(Button):show-changes') }}
                </Button>
            </template>
        </HamletTable>
    </div>
</template>

<style scoped lang="scss">

</style>
